// extracted by mini-css-extract-plugin
export default {"MainDash":"dashboard_MainDash__QtSgk"};